import { ReturnStruct } from "src/app/shared/structs/return.struct";

export class GenerateEpisodeResponse extends ReturnStruct {
    public idEpisode: number | null = null;
    public ticketSequence: number | null = null;

    public healthUnitName: string = '';
    public ticketInitials: string = '';
    public totemButtonName: string = '';
    public printerName: string = '';
    public qrCodeImage: string = '';
    public patientName: string = '';

    public ticketGenerationDate: Date | null = null;

}